export interface CreateUserResponseDto {
  authorization_url: string;
  access_code: string;
  reference: string;
}

export interface UserInfoDto {
  id: number | null;
  email: string;
  password: string;
  isActive: number | null;
  surname: string;
  othername: string;
  phoneNumber: string;
  planId: number | null;
  pendingPage: string;
  planAllowPage: string;
  accountType: string;
  nextStep: number | null;
  isStepCompleted: number | null;
  paymentReferenceId: string;
  homeAddress: string;
  gender: string;
  maritalStatus: string;
  dateOfBirth: string;
  identificationType: string;
  identificationId: string;
  identificationBase64: string;
  identificationPath: string;
  passportLastName: string;
  rememberToken: any;
  isAccountLocked: number | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  image: string;
  instructionTitle: string;
  instructionDescription: string;
  sentForApproval: number | null;
  deactiveReason: string | null;
  isArchived: boolean;
  isStaffAgent: boolean;
  staffAgentId: number | null;
  staffManagerAgentId: number | null;
  onBoardingSkip: number | null;
}

export const initialUserValue = {
  id: null,
  email: '',
  password: '',
  isActive: null,
  surname: '',
  othername: '',
  phoneNumber: '',
  planId: null,
  pendingPage: '',
  planAllowPage: '',
  accountType: 'client',
  nextStep: null,
  isStepCompleted: null,
  paymentReferenceId: '',
  homeAddress: '',
  gender: '',
  maritalStatus: '',
  dateOfBirth: '',
  identificationType: '',
  identificationId: '',
  identificationBase64: '',
  identificationPath: '',
  passportLastName: '',
  rememberToken: null,
  isAccountLocked: null,
  createdAt: '',
  updatedAt: '',
  deletedAt: null,
  image: '',
  instructionTitle: '',
  instructionDescription: '',
  sentForApproval: null,
  deactiveReason: '',
  isArchived: false,
  isStaffAgent: false,
  staffAgentId: null,
  staffManagerAgentId: null,
  onBoardingSkip: null
};
